<template>
  <div class="top-right-chart-container">
    <div class="top-right-chart-inner"></div>
  </div>
</template>

<script>
export default {
  name: "BrokersTopRightChartsContainer"
};
</script>

<style scoped>
.top-right-chart-container {
  float: right;
  width: calc(45%);
  background: white;
}

.top-right-chart-inner {
  overflow: hidden;
  min-height: 100%;
  position: relative;
  font-family: Montserrat;
  padding-top: 12px;
  padding-right: 12px;
  margin-right: 1px;
}
</style>
